import { SHIFT_GROUP_FETCHING, SHIFT_GROUP_FAILED, SHIFT_GROUP_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SHIFT_GROUP_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case SHIFT_GROUP_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case SHIFT_GROUP_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
};
